import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form';

import { TextInput, SelectInput, SwitchInput, RadioInput, MultiSelectInput, CardElement } from '../../_Components';

const EssenceOptions = [
    { id: 'lead', name: 'Лид', hint: 'crm.lead' },
    { id: 'contact', name: 'Контакт', hint: 'crm.contact' },
    { id: 'company', name: 'Компанию', hint: 'crm.company' },
    { id: 'company_contact', name: 'Контакт → Компанию', hint: 'связанная пара' },
    { id: 'contact_lead', name: 'Контакт → Лид', hint: 'связанная пара' },
];

const Entity_type = [
    { id: 'LEAD', name: 'Лид' },
    { id: 'CONTACT', name: 'Контакт' },
    { id: 'COMPANY', name: 'Компания' },
];

const Settings = ({ comboboxes, scripts, formValues, phoneFields, integration, isLoading }) => {
    const hasCrm = integration && integration.type !== 'None';
    const searchOn = formValues && formValues.search && formValues.search.value;

    return (
        <div className="pc-fill" style={{ overflow: 'auto' }}>
            <div className="pc-grid" style={{ alignContent: 'start' }}>
                <CardElement
                    title="Основное"
                    content={(
                        <div>
                            <div className="pc-sect">
                                <div className="pc-fgrid pc-fgrid--4">
                                    <Field
                                        name="name"
                                        required={true}
                                        component={TextInput}
                                        label="Название"
                                    />
                                    <Field
                                        name="task"
                                        required={true}
                                        component={SelectInput}
                                        options={comboboxes}
                                        label="Справочник тем"
                                    />
                                    <Field
                                        name="result"
                                        required={true}
                                        component={SelectInput}
                                        options={comboboxes}
                                        label="Справочник результатов"
                                    />
                                    <Field
                                        name="rating"
                                        component={TextInput}
                                        label="Сценарий оценки"
                                    />
                                    <Field
                                        name="script.default"
                                        required={true}
                                        component={SelectInput}
                                        options={scripts}
                                        label="Скрипт"
                                    />
                                    <Field
                                        name="oldScript"
                                        component={TextInput}
                                        label="Скрипт (старый)"
                                        mono={true}
                                    />
                                </div>
                                {formValues && formValues.oldScript ? (
                                    <div className="pc-field__hint" style={{ marginTop: 8 }}>
                                        Прежний номер скрипта оставлен для старых отчётов.
                                    </div>
                                ) : null}
                            </div>

                            {hasCrm && (
                                <div className="pc-sect">
                                    <div className="pc-sect__t">Что создавать в CRM по итогу звонка</div>
                                    {isLoading ? (
                                        <div className="pc-field__hint" style={{ marginBottom: 8 }}>
                                            Ждём ответ API — выбор сущности временно недоступен.
                                        </div>
                                    ) : null}
                                    <Field
                                        name="create.essence"
                                        required={true}
                                        component={RadioInput}
                                        variant="cards"
                                        columns={5}
                                        options={EssenceOptions}
                                    />
                                    <div className="pc-fgrid" style={{ marginTop: 13 }}>
                                        <div>
                                            <Field
                                                name="search.contact_phone"
                                                required={true}
                                                component={SelectInput}
                                                options={(phoneFields || []).map((item) => ({ id: item.value, name: item.label }))}
                                                label="Поле с контактным телефоном"
                                            />
                                            <div className="pc-field__hint">По нему ищется существующая запись в CRM.</div>
                                        </div>
                                        <Field
                                            name="search.entity_type"
                                            required={true}
                                            component={MultiSelectInput}
                                            options={Entity_type}
                                            label="Где искать"
                                        />
                                    </div>
                                </div>
                            )}

                            {hasCrm && (
                                <div className="pc-sect">
                                    <div className="pc-sect__t">Поведение</div>
                                    <div className="pc-fgrid">
                                        <div>
                                            <div className="pc-togrow">
                                                <div className="pc-togrow__txt">
                                                    <b>Создавать автоматически</b>
                                                    <span>Если записи нет — создать без вопроса оператору.</span>
                                                </div>
                                                <Field name="create.create" component={SwitchInput} />
                                            </div>
                                            <div className="pc-togrow">
                                                <div className="pc-togrow__txt">
                                                    <b>Поиск по базе</b>
                                                    <span>Оператор видит найденную карточку клиента.</span>
                                                </div>
                                                <Field name="search.value" component={SwitchInput} />
                                            </div>
                                        </div>
                                        <div>
                                            {searchOn && (
                                                <div className="pc-togrow">
                                                    <div className="pc-togrow__txt">
                                                        <b>Запись в CRM</b>
                                                        <span>Отправлять результат звонка в Bitrix.</span>
                                                    </div>
                                                    <Field name="search.crm" component={SwitchInput} />
                                                </div>
                                            )}
                                            {searchOn && (
                                                <div className="pc-togrow">
                                                    <div className="pc-togrow__txt">
                                                        <b>Внешняя интеграция</b>
                                                        <span>Передавать данные по правилам вкладки «Интеграция».</span>
                                                    </div>
                                                    <Field name="search.integration" component={SwitchInput} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    const formValues = getFormValues('card')(state);
    const { fetch } = state;
    return {
        formValues,
        isLoading: !!(fetch && fetch.loading),
    };
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    }),
);

export default enhance(Settings);
